import { ref } from '@vue/composition-api'

// KP-4621: whether the open collection is unavailable to the viewer. The catalog answers
// "Collection not found" (404) for an unknown collection and for one the retailer's
// segmentation hides completely.
//
// `latest(promise)` wraps each products fetch: only the newest request may change the
// page. An older response that lands later (e.g. switching retailers quickly in View as
// Retailer) is turned into STALE_RESPONSE, which the error handler ignores. A successful
// newest response clears the flag; a 404 sets it from the message (see
// collectionProductsHelpers.applyProductsFetchError); any other error leaves it as is.
export const STALE_RESPONSE = Symbol('stale-products-response')

export function useCollectionAvailability() {
  const isCollectionUnavailable = ref(false)
  let newest = 0

  const latest = promise => {
    newest += 1
    const request = newest
    const ensureNewest = () => {
      if (request !== newest) throw STALE_RESPONSE
    }
    return promise.then(
      response => {
        ensureNewest()
        isCollectionUnavailable.value = false
        return response
      },
      error => {
        ensureNewest()
        throw error
      },
    )
  }

  return { isCollectionUnavailable, latest }
}
